<div>
    <h6 class="text-secondary fw-bold" *ngIf="!actions">Consulta de solicitud de servicio disponible para programación</h6>

    <div class="d-flex flex-rol col-md-2 gap-2" *ngIf="actions">
        <input
            id="typeahead-format"
            type="text"
            class="form-control"
            placeholder="Buscar" 
            [(ngModel)]="idSolicitudRelacionada"/>

            <button class="btn btn-outline-secondary btn-sm" (click)="onSearchRequest()">
                <i class="fa-sharp fa-solid fa-magnifying-glass"></i>
            </button>
    </div>
    <br>
    <div class="overflow-auto">
        <table class="table table-bordered text-center">
            <thead>
                <tr>
                    <th scope="col">ID solicitud</th>
                    <th scope="col">Dependencia</th>
                    <th scope="col">Referente</th>
                    <th scope="col">Director</th>
                    <th scope="col">Fecha solicitud del servicio</th>
                    <th scope="col">Fecha de prestación del servicio</th>
                    <th scope="col">Trayecto</th>
                    <th scope="col">Origen</th>
                    <th scope="col">Destino</th>
                    <th scope="col">Hora salida</th>
                    <th scope="col">Hora llegada</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Tipo de vehículo</th>
                    <th scope="col">Conductor</th>
                    <th scope="col" *ngIf="actions">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{solicitud.id}}</td>
                    <td>{{solicitud.dependencia ? solicitud.dependencia.vcNombre : null}}</td>
                    <td>{{solicitud.referente ? solicitud.referente.vcNombreCompleto : null}}</td>
                    <td>{{solicitud.directorJefeDependencia ? solicitud.directorJefeDependencia.vcNombre : null }}</td>
                    <td>{{solicitud.dtFechaSolicitud}}</td>
                    <td>{{solicitud.dtFechaPrestacionServicio}}</td>
                    <td>{{solicitud.tipoServicio ? solicitud.tipoServicio.vcNombre : null}}</td>
                    <td>{{solicitud.recorridos.length > 0 ? solicitud.recorridos[0].vcLugarSalida : null }}</td>
                    <td>{{solicitud.recorridos[dataTable.recorridos.length - 1]?.vcLugarDestino }}</td>
                    <td>{{solicitud.recorridos.length > 0 ? solicitud.recorridos[0].dtHoraSalida : null }}</td>
                    <td>{{solicitud.recorridos[dataTable.recorridos.length - 1]?.dtHoraRecogida }}</td>
                    <td>{{solicitud.maquinaEstado?.vcNombre}}</td>
                    <td>{{solicitud.vehiculo?.clase.txDescripcion || solicitud.vehiculoSubContratado?.clase.txDescripcion}}</td>
                    <td>{{solicitud.conductor?.vcNombreCompleto}}</td>
                    <td *ngIf="actions">
                        <div class="container">
                            <button class="btn btn-outline-secondary btn-sm" (click)="onRelate()">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>